import React from "react";
import { AUTH_PREFIX_PATH, APP_PREFIX_PATH } from "configs/AppConfig";

export const publicRoutes = [
  {
    key: "login",
    path: `${AUTH_PREFIX_PATH}/login`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/login")
    ),
  },
  {
    key: "password-change",
    path: `/password-change`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/reset-password")
    ),
  },
  {
    key: "register",
    path: `${AUTH_PREFIX_PATH}/register`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/register")
    ),
  },
  {
    key: "forgot-password",
    path: `${AUTH_PREFIX_PATH}/forgot-password`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/forgot-password")
    ),
  },
  {
    key: "not-authorized",
    path: `${APP_PREFIX_PATH}/not-authorized`,
    component: React.lazy(() => import("views/app-views/NotAuthorized")),
  },
];

export const protectedRoutes = [
  {
    key: "dashboard",
    path: `${APP_PREFIX_PATH}/dashboard`,
    component: React.lazy(() => import("views/app-views/home")),
  },
  {
    key: "kpis",
    path: `${APP_PREFIX_PATH}/kpis`,
    component: React.lazy(() =>
      import("views/app-views/growth/GrowthKPIs")
    ),
  },
  {
    key: "growth-kpis",
    path: `${APP_PREFIX_PATH}/growth/kpis`,
    component: React.lazy(() =>
      import("views/app-views/growth/GrowthKPIs")
    ),
  },
  {
    key: "lead-generation",
    path: `${APP_PREFIX_PATH}/growth/lead-generation`,
    component: React.lazy(() =>
      import("views/app-views/growth/GrowthLeadGeneration")
    ),
  },
  {
    key: "lead-prospect",
    path: `${APP_PREFIX_PATH}/growth/lead-prospect`,
    component: React.lazy(() => import("views/app-views/growth/GrowthLead")),
  },
  {
    key: "prospect-customer",
    path: `${APP_PREFIX_PATH}/growth/prospect-customer`,
    component: React.lazy(() =>
      import("views/app-views/growth/GrowthCustomer")
    ),
  },
  {
    key: "prospect-subscription",
    path: `${APP_PREFIX_PATH}/growth/prospect-subscription`,
    component: React.lazy(() =>
      import("views/app-views/coming-soon/ComingSoon")
    ),
  },
  {
    key: "prospect-refund",
    path: `${APP_PREFIX_PATH}/growth/prospect-refund`,
    component: React.lazy(() =>
      import("views/app-views/growth/RefundStatistics")
    ),
  },
  {
    key: "retention",
    path: `${APP_PREFIX_PATH}/retention`,
    component: React.lazy(() =>
      import("views/app-views/coming-soon/ComingSoon")
    ),
  },
  {
    key: "finance",
    path: `${APP_PREFIX_PATH}/finance`,
    component: React.lazy(() =>
      import("views/app-views/coming-soon/ComingSoon")
    ),
  },
  {
    key: "customers-overview",
    path: `${APP_PREFIX_PATH}/customers/overview`,
    component: React.lazy(() => import("views/app-views/customers/Customers")),
  },
  {
    key: "customers-list",
    path: `${APP_PREFIX_PATH}/customers`,
    component: React.lazy(() =>
      import("views/app-views/user-list/subscriptions")
    ),
  },
  {
    key: "users-chat",
    path: `${APP_PREFIX_PATH}/customers/chats`,
    component: React.lazy(() => import("views/app-views/Chat-history")),
  },
  {
    key: "projects",
    path: `${APP_PREFIX_PATH}/projects`,
    component: React.lazy(() =>
      import("views/app-views/tasks/project/ProjectList")
    ),
  },
  {
    key: "project-details",
    path: `${APP_PREFIX_PATH}/projects/:id`,
    component: React.lazy(() =>
      import("views/app-views/tasks/project/ProjectDetails.js")
    ),
  },
  {
    key: "tasks",
    path: `${APP_PREFIX_PATH}/customers/tasks`,
    component: React.lazy(() =>
      import("views/app-views/tasks/taskSection/TaskSection")
    ),
  },
  {
    key: "pipeline",
    path: `${APP_PREFIX_PATH}/customers/pipeline`,
    component: React.lazy(() =>
      import("views/app-views/pipeline/PipelinePage")
    ),
  },
  {
    key: "ab-tests",
    path: `${APP_PREFIX_PATH}/ab-test`,
    component: React.lazy(() =>
      import("views/app-views/home/statistics/ABTesting.js")
    ),
  },
  {
    key: "project-templates",
    path: `${APP_PREFIX_PATH}/template`,
    component: React.lazy(() =>
      import("views/app-views/project-template/Template")
    ),
  },
  {
    key: "template-details",
    path: `${APP_PREFIX_PATH}/templates/:id`,
    component: React.lazy(() =>
      import("views/app-views/project-template/TemplateDetails")
    ),
  },
  {
    key: "administrators",
    path: `${APP_PREFIX_PATH}/users/administrators`,
    component: React.lazy(() => import("views/app-views/user-list/admins")),
  },
  {
    key: "configuration",
    path: `${APP_PREFIX_PATH}/configuration`,
    component: React.lazy(() =>
      import("views/app-views/configuration/Configuration")
    ),
  },
  {
    key: "system-logs",
    path: `${APP_PREFIX_PATH}/logs`,
    component: React.lazy(() => import("views/app-views/logs")),
  },
  // Keep existing routes for backward compatibility
  {
    key: "subscriptions",
    path: `${APP_PREFIX_PATH}/users/subscriptions`,
    component: React.lazy(() =>
      import("views/app-views/user-list/subscriptions")
    ),
  },
  {
    key: "user-details",
    path: `${APP_PREFIX_PATH}/users/subscriptions/details/:id`,
    component: React.lazy(() => import("views/app-views/user-details")),
  },
  {
    key: "orders",
    path: `${APP_PREFIX_PATH}/orders`,
    component: React.lazy(() => import("views/app-views/orders")),
  },
  {
    key: "Activity",
    path: `${APP_PREFIX_PATH}/activity`,
    component: React.lazy(() =>
      import("views/app-views/activity/ActivityPage")
    ),
  },
  {
    key: "agency",
    path: `${APP_PREFIX_PATH}/agency`,
    component: React.lazy(() => import("views/app-views/agency/Agency")),
  },
  {
    key: "growth-lead",
    path: `${APP_PREFIX_PATH}/growth/lead`,
    component: React.lazy(() => import("views/app-views/growth/GrowthLead")),
  },
  {
    key: "growth-customer",
    path: `${APP_PREFIX_PATH}/growth/customer`,
    component: React.lazy(() =>
      import("views/app-views/growth/GrowthCustomer")
    ),
  },
  {
    key: "growth-refunds",
    path: `${APP_PREFIX_PATH}/growth/refunds`,
    component: React.lazy(() =>
      import("views/app-views/growth/RefundStatistics")
    ),
  },
];
